import React from 'react'
import { Field } from 'redux-form'
import LgySelectField from 'app/components/util/lgy-select-field/LgySelectField'
import { required } from 'app/utils/validations'

const UserTypeSelect = () =>
  <Field component={LgySelectField} label='I am a...' name='userType' validate={required} required>
    <option value='Appraiser'>Appraiser</option>
    <option value='DOD User'>DOD User</option>
    <option value='Inspector'>Inspector</option>
    <option value='Lender'>Lender</option>
    <option value='LGY CO User'>LGY CO User</option>
    <option value='Other Requester'>Other Requester</option>
    <option value='RLC User'>RLC User</option>
    <option value='SAR'>LAPP/SAPP SAR</option>
    <option value='Servicer'>Servicer</option>
    <option value='VSO User'>Veteran Service Organization (VSO) User</option>
    <option value='NCC User'>VA National Call Center (NCC) User</option>
    <option value='Other'>Other/Don't Know</option>
  </Field>

export default UserTypeSelect